export const LEGO_VALIDATION_RULES = {
  password: {
    value: /^(?! )(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[^ ]{8,32}$/,
    message: 'Минимум 8 символов, должен состоять из цифр, строчных, заглавных букв и не содержать пробел',
  },
  passwordConfirm: {
    message: 'Пароль не совпадает',
  },
};
